import { render, staticRenderFns } from "./ClaimLogs.vue?vue&type=template&id=9a80b51c"
import script from "./ClaimLogs.vue?vue&type=script&lang=js"
export * from "./ClaimLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports